<template>
    <div v-loading.fullscreen.lock="loading">
        <cop-template-search-bar-component
            add_auth="新增订舱模板"
            :Allstaff="Allstaff"
            @search="get_cop_template_index"
            @addTeam="addTeam"
        ></cop-template-search-bar-component>
        <common-table-component
            details_auth="订舱模板详情"
            :col_arr="fcol_arr"
            :table_data="ftable_data"
            @details_row="details_cop_template"
        ></common-table-component>
        <common-page-component
            :current_page="cond.page"
            :page_size="cond.limit"
            :total="ftotal"
            @search="get_cop_template_index"
        ></common-page-component>
        <cop-template-edit-component
            edit_auth="修改订舱模板"
            del_auth="删除订舱模板"
            :id="fid"
            :show_type="edit_type"
            :dialogFormVisible="fdialogFormVisible"
            :cop_template_details_data="fcop_template_details_data"
            @exitDialog="dialogExit"
            @search="get_cop_template_index"
            @show_edit="show_edit"
            @details_row="details_cop_template"
        ></cop-template-edit-component>
    </div>
</template>

<script>
import { cop_template_index_request,cop_template_details_request } from '@/network/cop/CopTemplate.js'
import { staff_list_request } from '@/network/list.js'

import CopTemplateSearchBarComponent from '@/components/cop/CopTemplate/CopTemplateSearchBarComponent'
import CommonTableComponent from '@/components/common/CommonTableComponent'
import CommonPageComponent from '@/components/common/CommonPageComponent'
import CopTemplateEditComponent from '@/components/cop/CopTemplate/CopTemplateEditComponent'

export default {
    name: 'CopTemplateView',
    data() {
        return {
            fid: 0,
            edit_type: 0,
            fdialogFormVisible: false,
            loading: false,
            ftotal: 0,
            cond: {
                name: '',
                create_staff: '',
                page: 1,
                limit: 10,
            },
            ftable_data: [],
            fcol_arr: [
                {
                    prop: 'name',
                    label: '模板名称',
                    minWidth: '300px'
                },
                {
                    prop: 'create_staff_name',
                    label: '创建人',
                    minWidth: '120px'
                },
                {
                    prop: 'create_time',
                    label: '创建时间',
                    minWidth: '220px'
                }
            ],
            fcop_template_details_data: {},
            Allstaff: []
        }
    },
    computed: {},
    methods: {
        addTeam() {
            this.edit_type = 1
            this.fdialogFormVisible = true
        },
        show_edit() {
            this.edit_type = 2
        },
        get_cop_template_index(param = {}) {
            this.loading = true
            this.cond.name = param.name ?? this.cond.name
            this.cond.create_staff = param.create_staff ?? this.cond.create_staff
            this.cond.page = param.page ?? this.cond.page
            if (param.limit) {
                this.cond.limit = param.limit
                this.cond.page = 1
            }

            cop_template_index_request(this.cond)
                .then((s) => {
                    this.loading = false
                    if (s.status === 0) {
                        this.ftable_data = s.result.data
                        this.ftotal = s.result.total
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.loading = false
                    this.$message.error(err)
                })
        },
        details_cop_template(id) {
            this.fid = id
            this.fdialogFormVisible = true
            cop_template_details_request(id)
                .then((s) => {
                    if (s.status === 0) {
                        this.fcop_template_details_data = s.result
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        dialogExit() {
            this.fdialogFormVisible = false
            this.fid = 0
            this.edit_type = 0
        },
        get_all_staff() {
            this.loading = true
            staff_list_request()
                .then((s) => {
                    this.loading = false
                    if (s.status === 0) {
                        this.Allstaff = s.result
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.loading = false
                    this.$message.error(err)
                })
        }
    },
    filters: {},
    props: {},
    created() {
        this.get_cop_template_index()
        this.get_all_staff()
    },
    destoryed() {},
    mounted() {},
    updated() {},
    components: {
        CopTemplateSearchBarComponent,
        CommonTableComponent,
        CommonPageComponent,
        CopTemplateEditComponent,
    },
    watch: {},
}
</script>

<style lang='less'></style>